export enum LocalTokens {
  LOG_LEVEL = 'logLevel',
  LOG_BATCH = 'logs',
  TOTAL_LOGS = 'logCount',
  BATCH_COUNT = 'currentBatchCount',
}
